// A referral pre-fills its clinical sections from the patient record. When one
// of those fetches fails the field is pre-filled as an empty string — identical
// to a patient with nothing recorded — so the GP has to be told which sections
// were composed from data we could not load (KIN-1614 / KIN-1616).
const PREFILL_SOURCES = [
  { key: "allergies", label: "allergies" },
  { key: "medicalHistory", label: "past medical history" },
  { key: "familyMedicalHistory", label: "family history" },
  { key: "longTermMedications", label: "current medications" },
  { key: "patientSocial", label: "lifestyle and social history" },
  { key: "patientBaseline", label: "vital signs and measurements" },
];

export const getPrefillErrorLabels = (errorsBySource = {}) =>
  PREFILL_SOURCES.filter(({ key }) => !!errorsBySource[key]).map(
    ({ label }) => label
  );
